<template>
  <div class="pray_record-wrap">
    <div class="head-wrap">
      <div class="head-topbar lite-page-top linebottom sticky">
        <div class="topbar-left" @click="$router.go(-1)"><i class="icon-arrow-left"></i></div>
        <div class="topbar-main"><h4>供奉记录</h4></div>
      </div>
    </div>
    <div class="record-list">
      <div class="listViewWrap">
        <div class="am-list am-list-view-scrollview">
          <div>
            <div class="am-list-body">
              <div class="list-view-section-body" v-for="(item, index) in goodsList" :key="index">
                <span>
                  <div class="record-item">
                    <div class="record-head">
                      <!-- <img src="../../assets/jnt/user.png" alt="" /> -->
                      <img :src="item.myProfile.headImgUrl" alt="" />
                    </div>
                    <div class="record-text">
                      <div class="record-text-name TextChangeToTwoLines">
                        <span>{{item.myProfile.nickname}}</span>
                        {{ item.content }}
                        <!-- 给墓园擦墓碑了 -->
                      </div>
                      <div class="record-text-time">
                        <span class="time">{{ fmtHistoryDate(item.createDate) }}</span>
                      </div>
                    </div>
                    <div class="record-goods">
                      <img
                        v-if="$properties(item.sourceSubtype, 'value') == 'clean'"
                        src="../../assets/jnt/clear.png"
                        alt=""
                      />
                      <img
                        v-if="$properties(item.sourceSubtype, 'value') == 'grass'"
                        src="../../assets/jnt/chucao.png"
                        alt=""
                      />
                      <img
                        v-if="$properties(item.sourceSubtype, 'value') == 'bow'"
                        src="../../assets/jnt/jugong1.png"
                        alt=""
                      />
                      <img
                        v-if="$properties(item.sourceSubtype, 'value') == 'knees'"
                        src="../../assets/jnt/guibai.png"
                        alt=""
                      />
                      <img
                        v-if="$properties(item.sourceSubtype, 'value') == 'candle'"
                        src="../../assets/jnt/lazhu1.png"
                        alt=""
                      />
                      <img
                        v-if="$properties(item.sourceSubtype, 'value') == 'goods'"
                        :src="item.targetPhoto"
                        alt=""
                      />
                    </div>
                  </div>
                </span>
              </div>
            </div>
            <div class="am-list-footer">
              <div style="padding: 5px; text-align: center;">没有更多数据了</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'history',
  data() {
    return {
      hallId: null,
      sourceType: null,
      goodsList: [],
      goodsTotal: 0,
    }
  },
  methods: {
    goto(str) {
      this.$router.push({ path: str })
    },
    fmtHistoryDate(createDate) {
      if (createDate) {
        if (
          moment(createDate, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') !=
          moment(new Date()).format('YYYY-MM-DD')
        ) {
          return moment(createDate, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm')
        } else {
          var totalMinute =
            moment(new Date()).diff(moment(createDate, 'YYYY-MM-DD HH:mm:ss')) / (1000 * 60)
          var hours = Math.floor(totalMinute / 60)
          var minute = Math.ceil(totalMinute % 60)
          var result = ''
          if (hours > 0) {
            result = result + hours + '小时'
          }
          if (minute > 0) {
            result = result + minute + '分钟前'
          }
          if (!result) {
            result = '1分钟内'
          }
          return result
        }
      }
    },
    queryHistoryPage() {
      var that = this
      this.$queryPage(
        'HallHistory',
        {
          hallId: this.hallId,
          sourceType: this.sourceType,
          'myProfile.id': 'isnotnull',
          sort: { createDate: 0 },
        },
        [
          'id,sourceType,sourceSubtype,content,targetPhoto,createDate,myProfile.id,myProfile.nickname,myProfile.headImgUrl',
        ],
        function(res) {
          that.$fill(that.goodsList, res.data)
          that.goodsTotal = res.total
        }
      )
    },
  },
  mounted() {
    var query = this.$route.query
    this.hallId = query.hallId
    this.sourceType = query.category == '1' ? 'hall' : 'mem'
    this.queryHistoryPage()
  },
  created() {},
}
</script>

<style>
.pray_record-wrap .head-wrap {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 4.09rem;
  background-color: #fff;
  border-bottom: 1px solid #f7f7f7;
  z-index: 10;
}
.pray_record-wrap .head-wrap .returnBack {
  position: absolute;
  left: 1.363rem;
  width: 6.733vw;
  height: 100%;
  display: flex;
  align-content: center;
  align-items: center;
  z-index: 10;
  cursor: pointer;
}
.pray_record-wrap .head-wrap .returnBack .icon-arrow-left {
  width: 0.8181rem;
  height: 1.363rem;
  background: url(../../assets/jnt/zjt1.png) no-repeat;
  background-size: 100% 100%;
  display: inline-block;
}
.pray_record-wrap .tab-box {
  width: 60%;
  margin-left: 20%;
}
.am-tabs-bottom,
.am-tabs-top {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}
.am-tabs,
.am-tabs * {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.am-tabs {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  position: relative;
  overflow: hidden;
  height: 100%;
  width: 100%;
}
.am-tabs-pane-wrap,
.am-tabs-tab-bar-wrap {
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}
.am-tabs-default-bar-bottom,
.am-tabs-default-bar-bottom .am-tabs-default-bar-content,
.am-tabs-default-bar-top,
.am-tabs-default-bar-top .am-tabs-default-bar-content {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
}
.am-tabs-default-bar,
.am-tabs-default-bar-tab {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}
.am-tabs-default-bar {
  width: 100%;
  height: 100%;
  overflow: visible;
  z-index: 1;
}
.am-tabs-default-bar,
.am-tabs-left,
.am-tabs-right {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
}
.am-tabs-default-bar-bottom .am-tabs-default-bar-content,
.am-tabs-default-bar-top .am-tabs-default-bar-content {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
}
.am-tabs-default-bar-bottom,
.am-tabs-default-bar-bottom .am-tabs-default-bar-content,
.am-tabs-default-bar-top,
.am-tabs-default-bar-top .am-tabs-default-bar-content {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
}
.am-tabs-default-bar-animated .am-tabs-default-bar-content {
  -webkit-transition: -webkit-transform 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  transition: -webkit-transform 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  transition: transform 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  transition: transform 0.3s cubic-bezier(0.35, 0, 0.25, 1),
    -webkit-transform 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  will-change: transform;
}
.pray_record-wrap .tab-box .am-tabs-default-bar-tab-active {
  color: #e4803c;
  font-weight: 500;
}
.pray_record-wrap .tab-box .am-tabs-default-bar-tab {
  font-size: 16px;
}
.am-tabs-default-bar-top .am-tabs-default-bar-tab {
  border-bottom: 1px solid #ddd;
}
.am-tabs-default-bar-bottom .am-tabs-default-bar-tab,
.am-tabs-default-bar-top .am-tabs-default-bar-tab {
  padding: 8px 0;
}
.am-tabs-default-bar-tab-active {
  color: #108ee9;
}
.am-tabs-default-bar-tab {
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 15px;
  height: 43.5px;
  line-height: 43.5px;
}
.am-tabs-default-bar,
.am-tabs-default-bar-tab {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}
.pray_record-wrap .tab-box.leftBar .am-tabs-default-bar-underline {
  left: 17% !important;
}
.pray_record-wrap .tab-box .am-tabs-default-bar-underline {
  border: 2px solid #e4803c;
  border-radius: 1.25px;
  width: 15% !important;
}
.am-tabs-default-bar-bottom .am-tabs-default-bar-underline,
.am-tabs-default-bar-top .am-tabs-default-bar-underline {
  bottom: 0;
}
.am-tabs-default-bar-animated .am-tabs-default-bar-underline {
  -webkit-transition: top 0.3s cubic-bezier(0.35, 0, 0.25, 1),
    left 0.3s cubic-bezier(0.35, 0, 0.25, 1), color 0.3s cubic-bezier(0.35, 0, 0.25, 1),
    width 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  transition: top 0.3s cubic-bezier(0.35, 0, 0.25, 1), left 0.3s cubic-bezier(0.35, 0, 0.25, 1),
    color 0.3s cubic-bezier(0.35, 0, 0.25, 1), width 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  will-change: top, left, width, color;
}
.am-tabs-default-bar-underline {
  position: absolute;
  border: 1px solid #108ee9;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}
.am-tabs-content-wrap-animated {
  -webkit-transition: left 0.3s cubic-bezier(0.35, 0, 0.25, 1),
    top 0.3s cubic-bezier(0.35, 0, 0.25, 1), -webkit-transform 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  transition: left 0.3s cubic-bezier(0.35, 0, 0.25, 1), top 0.3s cubic-bezier(0.35, 0, 0.25, 1),
    -webkit-transform 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  transition: transform 0.3s cubic-bezier(0.35, 0, 0.25, 1),
    left 0.3s cubic-bezier(0.35, 0, 0.25, 1), top 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  transition: transform 0.3s cubic-bezier(0.35, 0, 0.25, 1),
    left 0.3s cubic-bezier(0.35, 0, 0.25, 1), top 0.3s cubic-bezier(0.35, 0, 0.25, 1),
    -webkit-transform 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  will-change: transform, left, top;
}
.am-tabs-content-wrap {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  width: 100%;
  height: 100%;
  min-height: 0;
}
.am-tabs-horizontal .am-tabs-pane-wrap-active {
  height: auto;
}
.am-tabs-pane-wrap,
.am-tabs-tab-bar-wrap {
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}
.am-tabs-pane-wrap {
  width: 100%;
  overflow-y: auto;
}
.am-tabs-horizontal .am-tabs-pane-wrap-inactive {
  height: 0;
  overflow: visible;
}
.am-tabs-pane-wrap,
.am-tabs-tab-bar-wrap {
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}
.pray_record-wrap .record-list {
  width: 100%;
  padding: 5.453rem 1.363rem 0;
  box-sizing: border-box;
  z-index: 9;
}
.am-pull-to-refresh-content-wrapper {
  overflow: hidden;
}
.am-pull-to-refresh-transition {
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
}
.am-pull-to-refresh-content {
  -webkit-transform-origin: left top 0;
  -ms-transform-origin: left top 0;
  transform-origin: left top 0;
}
.am-pull-to-refresh-down .am-pull-to-refresh-indicator {
  margin-top: -25px;
}
.am-pull-to-refresh-indicator {
  color: grey;
  text-align: center;
  height: 25px;
}
.pray_record-wrap .listViewWrap .am-list-body {
  background-color: #f7f7f7;
}

element.style {
}
.record-list .record-item {
  width: 100%;
  background-color: #fff;
  border-radius: 0.682rem;
  margin-bottom: 0.91rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.363rem;
  box-sizing: border-box;
}
.record-list .record-item .record-head {
  width: 3.45rem;
  height: 3.45rem;
  border-radius: 50%;
  overflow: hidden;
}
.record-list .record-item .record-head img {
  width: 100%;
  border-radius: 50%;
}
.record-list .record-item .record-text {
  width: 19.27rem;
  padding: 10px;
  box-sizing: border-box;
}
.record-list .record-item .record-text .record-text-name {
  color: #333;
  font-size: 1.272rem;
  line-height: 1.5;
  margin-bottom: 1rem;
}
.TextChangeToTwoLines {
  -webkit-line-clamp: 2;
}
.TextChangeToOneLines,
.TextChangeToTwoLines {
  display: -webkit-box !important;
  overflow: hidden;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.record-list .record-item .record-text .record-text-name span {
  color: #193f71;
  display: inline-block;
  margin-right: 0.5rem;
}
.record-list .record-item .record-text .record-text-time {
  font-size: 1rem;
  color: #999;
  display: flex;
  justify-content: space-between;
}
.record-list .record-item .record-text .record-text-time {
  font-size: 1rem;
  color: #999;
  display: flex;
  justify-content: space-between;
}
.record-list .record-item .record-goods {
  width: 5.45rem;
  height: 5.45rem;
  border-radius: 3px;
  background-color: #ededed;
}
.record-list .record-item .record-goods img {
  width: 100%;
}
.am-list-footer {
  padding: 9px 15px 15px;
  font-size: 14px;
  color: #888;
}
.head-topbar.sticky {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
}
.head-topbar {
  display: flex;
  align-items: center;
  height: 3.8rem;
  background: #fff;
  position: fixed;
  width: 100%;
  z-index: 1;
}
.dashedlinebottom,
.dashedlinetop,
.linebottom,
.lineright,
.linetop {
  position: relative;
  -webkit-box-sizing: border-box;
  padding: 0;
}
.head-topbar .topbar-left {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.73333vw;
  position: absolute;
  left: 0.265rem;
  height: 100%;
  z-index: 10;
}

.head-topbar .topbar-left .icon-arrow-left {
  background: url(../../assets/jnt/left1.png) no-repeat;
  background-size: 100%;
  display: inline-block;
  height: 1.363rem;
  width: 0.818rem;
}
.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
.head-topbar .topbar-main {
  flex: 1;
  color: #333;
  font-size: 1.454rem;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: 400;
}
.head-topbar .topbar-right {
  padding-right: 1rem;
  position: absolute;
  right: 0.265rem;
  font-size: 1.272rem;
}
.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
